module.exports = __webpack_public_path__ + "img/food2.d758e5e7.jpg";